export const EVENT_CHANNEL = 'media';